export const wordFive = [
  {
    id: 1,
    text: "Lesson",
    response: "Every events in life has a lesson to learn.",
  },
  {
    id: 2,
    text: "Special",
    response: "The government should pay special attention to climate change.",
  },
  {
    id: 3,
    text: "Pool",
    response: "Discussion pools ideas.",
  },
  {
    id: 4,
    text: "Alike",
    response:
      "Cultural relation between India and Nepal is alike in many senses.",
  },
  {
    id: 5,
    text: "Affect",
    response: "Covid affected the labour class the most.",
  },
  {
    id: 6,
    text: "Attitude",
    response: "Attitude shapes character.",
  },
  {
    id: 7,
    text: "Always",
    response: "Life isn’t always easy.",
  },
  {
    id: 8,
    text: "Picnic",
    response: "A picnic is a great way to relax.",
  },
  {
    id: 9,
    text: "Climb",
    response: "Consistency is the ladder one must climb to excel.",
  },
  {
    id: 10,
    text: "Truth",
    response: "Be true to your work.",
  },
  {
    id: 11,
    text: "Self-Control",
    response: "Meditation is the best tool for self-control.",
  },
  {
    id: 12,
    text: "Soul",
    response: "Unity is the soul of the country.",
  },
  {
    id: 13,
    text: "Philosophy",
    response: "Non-violence is the political philosophy of Gandhi.",
  },
  {
    id: 14,
    text: "Playground",
    response: "Chail playground is the world’s highest stadium.",
  },
  {
    id: 15,
    text: "Joy",
    response: "One should find pride and joy in their work.",
  },
  {
    id: 16,
    text: "Crook",
    response: "One must be determined to succeed by hook or by crook..",
  },
  {
    id: 17,
    text: "Subordinate",
    response: "High court is subordinate to Supreme court.",
  },
  {
    id: 18,
    text: "Cut",
    response: "Words cut deeply than action.",
  },
  {
    id: 19,
    text: "Firm",
    response: "One must have firm control of their actions.",
  },
  {
    id: 20,
    text: "Join",
    response: "Where river joins sea is called estuaries.",
  },
  {
    id: 21,
    text: "Invoke",
    response: "Prayer invoke devotion.",
  },
  {
    id: 22,
    text: "Phone",
    response: "Smartphones revolutionized lives.",
  },
  {
    id: 23,
    text: "Transport",
    response: "Sea routes transport the most goods.",
  },
  {
    id: 24,
    text: "Border",
    response: "A soldier stands watchfull at the border.",
  },
  {
    id: 25,
    text: "Gain",
    response: "Kindness gains support.",
  },
  {
    id: 26,
    text: "Boredom",
    response: "Boredom leads to creativity.",
  },
  {
    id: 27,
    text: "Pull",
    response: "Promising market pulls investors.",
  },
  {
    id: 28,
    text: "Bill",
    response: "Money bill can only be introduced in Lok Sabha.",
  },
  {
    id: 29,
    text: "Weekend",
    response: "Weekend is the best time to spend with family.",
  },
  {
    id: 30,
    text: "Stock",
    response: "Stocks are smart investment.",
  },
  {
    id: 31,
    text: "Say",
    response: "What one believes must be said.",
  },
  {
    id: 32,
    text: "Police",
    response: "Police maintain public order.",
  },
  {
    id: 33,
    text: "Harsh",
    response: "Accident serves a harsh reminder of the importance of a helmet.",
  },
  {
    id: 34,
    text: "Mild",
    response:
      "Mild fever, cough, and tiredness are the most common symptoms of Covid.",
  },
  {
    id: 35,
    text: "Compulsion",
    response: "Certain situation makes us act under compulsion.",
  },
  {
    id: 36,
    text: "Relate",
    response: "Books relates to reality.",
  },
  {
    id: 37,
    text: "Grudge",
    response: "Friendly communication eliminates grudges.",
  },
  {
    id: 38,
    text: "Clash",
    response: "We must not clash over politics.",
  },
  {
    id: 39,
    text: "Oppose",
    response: "Oppositions keep governments in check.",
  },
  {
    id: 40,
    text: "Coach",
    response: "Dronacharya award honors outstanding coaches.",
  },
  {
    id: 41,
    text: "Normal",
    response: "Little setbacks are normal part of life.",
  },
  {
    id: 42,
    text: "Reconcile",
    response: "Disputes must always be reconciled.",
  },
  {
    id: 43,
    text: "Mental",
    response: "Mental health is as important as physical.",
  },
  {
    id: 44,
    text: "Listen",
    response: "I enjoy listening to classical music.",
  },
  {
    id: 45,
    text: "Unique",
    response: "Our talents makes us unique in the world.",
  },
  {
    id: 46,
    text: "Strange",
    response: "Strangerness puzzles people.",
  },
  {
    id: 47,
    text: "Glamour",
    response: "The acting career is filled with glitz and glamour.",
  },
  {
    id: 48,
    text: "Alien",
    response: "Communism is the idea alien to(incompatible with) democracy.",
  },
  {
    id: 49,
    text: "Barbaric",
    response:
      "Joseph Stalin is considered to be the most barbaric ruler of all time.",
  },
  {
    id: 50,
    text: "Green",
    response: "Recycling is the greener method of waste disposal.",
  },
  {
    id: 51,
    text: "Novel",
    response: "Some novels inspires us to be a better person.",
  },
  {
    id: 52,
    text: "Unusual",
    response: "One must be prepared to face unusual occurrences.",
  },
  {
    id: 53,
    text: "Attention",
    response: "Undivided attention makes study productive.",
  },
  {
    id: 54,
    text: "Sole",
    response:
      "Unethical human activities are the sole cause of environmental degradation.",
  },
  {
    id: 55,
    text: "Innovation",
    response:
      "India is witnessing the rapid pace of technological innovations.",
  },
  {
    id: 56,
    text: "Lack",
    response: "Many still lacks the basic necessities of life.",
  },
  {
    id: 57,
    text: "Hour",
    response: "One must help others in their hour of need.",
  },
  {
    id: 58,
    text: "Pain",
    response: "Pain and joy coexist in life.",
  },
  {
    id: 59,
    text: "Epitome",
    response: "Lata Mangeshkar was the epitome of simplicity.",
  },
  {
    id: 60,
    text: "Infamous",
    response: "Pakistan is the country infamous for terrorism.",
  },
];
